module.exports = __webpack_public_path__ + "img/active-24.2f5aee41.svg";